export default __webpack_public_path__ + "static/media/05.abfe2088.png";